import { useLocation } from 'react-router';

import useUserDetails from '@/hooks/useUserDetails';

const useIsPremiumAccess = () => {
  const location = useLocation();
  const { isUserPremium } = useUserDetails();

  return isUserPremium || !location.pathname.includes('dashboard');
};

export default useIsPremiumAccess;
